<template>
  <FormField label="Username">
    <Input v-model="credentials.username" autocomplete="off" data-testid="codebox-username" />
  </FormField>

  <FormField label="Password">
    <Input v-model="credentials.password" type="password" autocomplete="off" data-testid="codebox-password" />
  </FormField>

  <View justify="end">
    <Button
      :loading="connect.isLoading.value"
      :disabled="!credentials.username || !credentials.password"
      @click="onConnect"
      data-testid="codebox-connect"
    >
      Connect
    </Button>
  </View>
</template>

<script setup lang="ts">
import { reactive } from 'vue';

import { Button, FormField, Input, View } from '@tallo/design-system';

import { useConnectCodebox } from '../../mutations/codebox.mutation';

const connect = useConnectCodebox();
const credentials = reactive({ username: '', password: '' });

async function onConnect() {
  await connect.mutateAsync({ ...credentials });
  credentials.username = '';
  credentials.password = '';
}
</script>
